import { AdminApiError } from "../../hooks/useAdminList";

const LOCALE_MAP = { pt: "pt-PT", it: "it-IT", es: "es-ES", en: "en-IE" };

const intlLocale = () =>
  LOCALE_MAP[localStorage.getItem("__extraconomy_locale") || "it"] || "it-IT";

const isBlank = (value) => value === undefined || value === null || value === "";

// Mesmo formato monetário dos relatórios clássicos. Se a moeda vier inválida ou ausente,
// cai para EUR em vez de quebrar a tela (o clássico passava "-" ao Intl e lançava erro).
export const formatMoney = (value, currency = "EUR") => {
  if (isBlank(value)) return "—";
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return String(value);
  const code = typeof currency === "string" && /^[A-Z]{3}$/i.test(currency) ? currency : "EUR";
  try {
    return new Intl.NumberFormat(intlLocale(), { style: "currency", currency: code }).format(
      numeric,
    );
  } catch (e) {
    return `${code} ${numeric.toFixed(2)}`;
  }
};

export const formatReportDate = (value) => {
  if (isBlank(value)) return "—";
  // Os relatórios podem trazer timestamp numérico (em string) ou data ISO
  const date = /^\d+$/.test(String(value)) ? new Date(Number(value)) : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(intlLocale(), { timeZone: "UTC" }).format(date);
};

export const toTimestamp = (value) => {
  if (isBlank(value)) return 0;
  const date = /^\d+$/.test(String(value)) ? new Date(Number(value)) : new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

// Primeiro valor preenchido entre vários nomes de campo possíveis (aceita "a.b")
export const firstValue = (row, paths) => {
  for (const path of paths) {
    const value = path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), row);
    if (!isBlank(value)) return value;
  }
  return null;
};

export const sumBy = (rows, getter) =>
  rows.reduce((total, row) => {
    const value = Number(getter(row));
    return Number.isFinite(value) ? total + value : total;
  }, 0);

// Os endpoints de relatório devolvem ora um array direto, ora { messageCode, result }
export const toReportRows = (res) => {
  if (Array.isArray(res)) return res;
  if (res?.messageCode && res.messageCode !== 200001) throw new AdminApiError(res.messageCode);
  return Array.isArray(res?.result) ? res.result : [];
};

export const toApiDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")}`;
